<template>
  <div>
    <div class="row mb-3">
      <div class="col-md-8">
        <Heading title="Error Monitoring (Beta)" subTitle="In line with our commitment to make your store faster, we periodically scan your store for potential errors." targetPlan="basic" />
      </div>
    </div>

    <div class="row row-space-4">
      <div :class="{
        'col-md-6': true,
        'align-self-center': !hasProblems
      }">
        <div class="p-4">
          <img src="@/assets/img/error.svg" class="img-fluid" v-if="hasProblems" />
          <img src="@/assets/img/peace.svg" class="img-fluid" v-else />
        </div>
      </div>
      <div :class="{
        'col-md-6': true,
        'align-self-center': !hasProblems
      }">
        <div class="card bg-danger mb-3 bs" v-if="false">
          <ul class="list-group list-group-flush">
            <li class="list-group-item font-weight-normal">
              We have last scanned
              <code class="small mb-0" style="word-break: break-all;">{{url}}</code>
              on
              <code class="small mb-0" style="word-break: break-all;">{{date}}</code>.
            </li>
          </ul>
        </div>
        <Alert class="alert-info" icon="IconImportant" :title="'We have last scanned your store on ' + date">
          <p class="font-weight-normal mb-0" style="word-break: break-all;">The scanned url was {{url}}</p>
        </Alert>
        <div v-if="hasProblems">
          <Alert class="alert-attention" icon="IconImportant" title="These errors are neither related to Superchargify nor caused by Superchargify.">
            <p class="font-weight-normal mb-0">Some errors may impact the performance of your store. Please get in touch with your developer to fix the errors.</p>
          </Alert>
          <div class="card bg-danger mb-3 bs">
            <ul class="list-group list-group-flush">
              <li v-for="(error, idx) in vAuto.tests.errors" :key="idx" class="list-group-item">
                <div class="mb-1"><span :class="{
                  'badge': true,
                  [fixTypes(error.type).css]: true
                }">{{ fixTypes(error.type).text }}</span></div>
                <pre class="mb-0"><code>{{ error.text }}</code></pre>
              </li>
            </ul>
          </div>
        </div>
        <div class="card bs">
          <div class="card-body">
            <p class="font-weight-normal">You can manually submit a request to rescan your store.</p>

            <ProcessButton type="favicon" submitText="Rescan the store" successText="Your store is being scanned." />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { get } from 'lodash-es'

import ProcessButton from '@/components/ProcessButton'

export default {
  components: {
    ProcessButton
  },
  computed: {
    ...mapState([ 'vAuto', 'shopObj' ]),
    hasProblems: function () {
      const errors = get(this.vAuto, 'tests.errors') || []
      return errors.length > 0
    },
    date () {
      const stamp = get(this.vAuto, 'timestamp') || 1584983444117
      return new Date(stamp)
    },
    url () {
      return get(this.vAuto, 'url') || `https://${this.shopObj.domain}`
    }
  },
  methods: {
    fixTypes (type) {
      const map = {
        error: {
          text: 'Error',
          css: 'badge-danger'
        },
        pageerror: {
          text: 'Error',
          css: 'badge-danger'
        },
        'console:error': {
          text: 'Error',
          css: 'badge-danger'
        },
        'console:warning': {
          text: 'Warning',
          css: 'badge-primary'
        }
      }

      return map[type] || {}
    }
  }
}
</script>
